/** Toggles a value in a list, keeping order stable. */
export function toggleListValue<T>(list: readonly T[], value: T, on: boolean): T[] {
  const without = list.filter((v) => v !== value)
  return on ? [...without, value] : without
}
